// Convierte un monto en soles a su representacion en letras para recibos,
// ej: 50.00 -> "CINCUENTA CON 00/100 SOLES".

const UNIDADES = ['', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve'];
const ESPECIALES_10_19 = ['diez', 'once', 'doce', 'trece', 'catorce', 'quince',
  'dieciseis', 'diecisiete', 'dieciocho', 'diecinueve'];
const DECENAS: Record<number, string> = { 2: 'veinte', 3: 'treinta', 4: 'cuarenta', 5: 'cincuenta',
  6: 'sesenta', 7: 'setenta', 8: 'ochenta', 9: 'noventa' };
const CENTENAS: Record<number, string> = { 1: 'ciento', 2: 'doscientos', 3: 'trescientos', 4: 'cuatrocientos',
  5: 'quinientos', 6: 'seiscientos', 7: 'setecientos', 8: 'ochocientos', 9: 'novecientos' };

function seccionDecenas(n: number): string {
  if (n < 10) return UNIDADES[n];
  if (n < 20) return ESPECIALES_10_19[n - 10];
  const d = Math.floor(n / 10), u = n % 10;
  if (d === 2) return u === 0 ? 'veinte' : `veinti${UNIDADES[u]}`;
  const base = DECENAS[d];
  return u === 0 ? base : `${base} y ${UNIDADES[u]}`;
}

function seccionCentenas(n: number): string {
  if (n === 100) return 'cien';
  const c = Math.floor(n / 100), resto = n % 100;
  if (c === 0) return seccionDecenas(resto);
  const base = CENTENAS[c];
  return resto === 0 ? base : `${base} ${seccionDecenas(resto)}`;
}

function seccionMiles(n: number): string {
  if (n < 1000) return seccionCentenas(n);
  const miles = Math.floor(n / 1000), resto = n % 1000;
  const base = miles === 1 ? 'mil' : `${seccionCentenas(miles)} mil`;
  return resto === 0 ? base : `${base} ${seccionCentenas(resto)}`;
}

export function montoALetras(monto: number): string {
  const entero = Math.floor(monto);
  const centavos = Math.round((monto - entero) * 100);
  const centavosStr = String(centavos).padStart(2, '0');
  const letras = entero === 0 ? 'cero' : seccionMiles(entero);
  return `${letras.toUpperCase()} CON ${centavosStr}/100 SOLES`;
}
